module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mariya@2x_aad0af.png";